"use client";

import type { ReactNode } from "react";

type Props = {
    /** 選択されたファイル群を即時に渡す（選択後 input はリセットし同一ファイル再選択を可能にする）。 */
    onPick: (files: File[]) => void;
    multiple?: boolean;
    accept?: string;
    disabled?: boolean;
    /** ラベルの見た目。未指定なら②の既定ボタン。inlineActionClass 等を渡して文脈に合わせる。 */
    className?: string;
    ariaLabel?: string;
    children: ReactNode;
};

const DEFAULT =
    "cursor-pointer rounded border border-border-subtle bg-surface px-2 py-1 text-text-secondary hover:bg-sidebar-bg";

/** ②のファイル選択ボタン。ラベルを<button>風に見せ、隠した<input type=file>を内包する。選択即時 onPick。 */
export function FilePickerButton({
    onPick,
    multiple,
    accept,
    disabled,
    className,
    ariaLabel,
    children,
}: Props) {
    return (
        <label
            className={`${className ?? DEFAULT} ${disabled ? "pointer-events-none opacity-40" : ""}`}
        >
            {children}
            <input
                type="file"
                multiple={multiple}
                accept={accept}
                disabled={disabled}
                aria-label={ariaLabel}
                // Tailwind の `hidden` ユーティリティに依存せずインラインで隠す（ラベル経由で
                // ダイアログは開く）。`.hidden` 未生成環境でもネイティブ input が露出しない。
                style={{ display: "none" }}
                onChange={(e) => {
                    onPick(Array.from(e.target.files ?? []));
                    e.target.value = "";
                }}
            />
        </label>
    );
}
